import { z } from 'zod';

/**
 * Pro-Quiz konfigurierbare Punktelogik.
 * Die tatsächliche Berechnung erfolgt AUSSCHLIESSLICH serverseitig (siehe apps/api).
 * Dieser Typ und die Defaults sind geteilt, damit das Host-Backend dieselben
 * Grenzen/Bezeichnungen kennt wie der Server.
 */
export const scoringConfigSchema = z.object({
  /** Grundpunkte für eine (voll) richtige Antwort. */
  basePoints: z.number().int().min(0).max(100_000).default(1000),
  /** Zeitbonus aktiv: fällt linear mit der verstrichenen Antwortzeit. */
  timeBonusEnabled: z.boolean().default(true),
  /**
   * Anteil der Grundpunkte, der maximal als Zeitbonus obendrauf kommt (0..1).
   * Beispiel 0.5 => bei sofortiger richtiger Antwort bis zu +50 % Bonus.
   */
  timeBonusMaxRatio: z.number().min(0).max(2).default(0.5),
  /** Streak-Bonus für Serien richtiger Antworten. */
  streakBonusEnabled: z.boolean().default(true),
  /** Streak zählt erst ab dieser Länge (z. B. ab der 2. richtigen in Folge). */
  streakMinLength: z.number().int().min(2).max(50).default(2),
  /** Bonus pro Streak-Stufe. */
  streakBonusPerStep: z.number().int().min(0).max(10_000).default(100),
  /** Obergrenze des Streak-Bonus. */
  streakBonusCap: z.number().int().min(0).max(100_000).default(500),
  /** Punktabzug bei falscher Antwort (Standard: aus). */
  penaltyOnWrong: z.boolean().default(false),
  /** Höhe des Abzugs bei falscher Antwort, falls aktiv. */
  penaltyPoints: z.number().int().min(0).max(100_000).default(0),
});

export type ScoringConfig = z.infer<typeof scoringConfigSchema>;

export const DEFAULT_SCORING_CONFIG: ScoringConfig = scoringConfigSchema.parse({});
